/*IT'S COMMON COMPONENTS FOR ALL PAGES*/

import Vue from 'vue';

// ** Navigation ** //
Vue.component('header-app', require('./partial/Header').default);

// ** Navigation ** //
Vue.component('footer-app', require('./partial/Footer').default);

// ** Search ** //
Vue.component('search-app', require('./partial/search/Index').default);

// ** Modals ** //
Vue.component('add-basket-modal', require('./partial/modals/addBasketModal').default);
Vue.component('show-card-modal', require('./partial/modals/showCardModal').default);
Vue.component('modal-calendar', require('./partial/modals/modalCalendar').default);
Vue.component('feedback-form', require('./partial/Feedback').default);

// ** Catalog common parts ** //
Vue.component('catalog-categories', require('./partial/filter/Categories').default);
Vue.component('catalog-category-card', require('./partial/filter/CategoryCard').default);
